import { c as _c } from "react/compiler-runtime";
import type { MultilingualText, PublicFaceFieldsFragment } from 'api-graphql-types';
import { Heading, LayoutStack } from 'design-system/client';
import Image from 'next/image';
import { useTranslations, useLocale } from 'next-intl';
import { memo } from 'react';
import { formatDate } from '../../../helpers';
import styles from './FundraisingEventDescription.module.css';
import TextLink from '@/components/TextLink';
import TrustedHtml from '@/components/TrustedHtml';
import { RailsRoutes } from '@/helpers/utils';
import type { Maybe } from '@/types';
type FundraisingEventDescriptionProps = {
  description?: Maybe<MultilingualText>;
  publicFace: PublicFaceFieldsFragment;
  createdAt: Date | string;
};
function FundraisingEventDescription(t0) {
  const $ = _c(47);
  const {
    description: description_,
    publicFace,
    createdAt
  } = t0;
  const locale = useLocale();
  const fallbackLocale = locale === "de" ? "en" : "de";
  const t = useTranslations("nextjs.receiver_pages.fundraising_event");
  const description = description_?.[locale] || description_?.[fallbackLocale] || "";
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== createdAt || $[1] !== description || $[2] !== publicFace.imageUrl100x100 || $[3] !== publicFace.name || $[4] !== t) {
    const date = formatDate(createdAt);
    t6 = styles.container;
    let t8;
    if ($[13] !== t) {
      t8 = t("what_is_it_about");
      $[13] = t;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    if ($[15] !== t8) {
      t7 = <Heading as="h2" level="heading-sm" className={styles.title}>{t8}</Heading>;
      $[15] = t8;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    T0 = LayoutStack;
    t4 = "400";
    if ($[17] !== description) {
      t5 = <div className={styles.descriptionContainer}><TrustedHtml value={description} as="div" /></div>;
      $[17] = description;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t2 = styles.managerContainer;
    if ($[19] !== publicFace.imageUrl100x100) {
      t3 = <Image src={publicFace.imageUrl100x100} height={100} width={100} alt="" className={styles.image} />;
      $[19] = publicFace.imageUrl100x100;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    t1 = t("additional_information", {
      manager: publicFace.name,
      date
    });
    $[0] = createdAt;
    $[1] = description;
    $[2] = publicFace.imageUrl100x100;
    $[3] = publicFace.name;
    $[4] = t;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[21] !== t1) {
    t8 = <p>{t1}</p>;
    $[21] = t1;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== locale || $[24] !== publicFace.id) {
    t9 = RailsRoutes.message({
      locale,
      recipient: publicFace.id
    });
    $[23] = locale;
    $[24] = publicFace.id;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t) {
    t10 = t("write_a_message");
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = <TextLink prefetch={false} href={t9}>{t10}</TextLink>;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t8) {
    t12 = <div>{t8}{t11}</div>;
    $[31] = t11;
    $[32] = t8;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t2 || $[36] !== t3) {
    t13 = <div className={t2}>{t3}{t12}</div>;
    $[34] = t12;
    $[35] = t2;
    $[36] = t3;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== T0 || $[39] !== t13 || $[40] !== t4 || $[41] !== t5) {
    t14 = <T0 space={t4}>{t5}{t13}</T0>;
    $[38] = T0;
    $[39] = t13;
    $[40] = t4;
    $[41] = t5;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14 || $[44] !== t6 || $[45] !== t7) {
    t15 = <section className={t6}>{t7}{t14}</section>;
    $[43] = t14;
    $[44] = t6;
    $[45] = t7;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
}
export default memo(FundraisingEventDescription);